export default __webpack_public_path__ + "static/media/search.7843e1e0.svg";